export default function Features() {
  return (
    <section id="features" className="py-32 bg-gray-900">
      <div className="px-8 lg:px-24">
        <div className="mb-4">
          <span
            className="text-lg font-light text-gray-500 tracking-wide"
            style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}
          >
            SOMA
          </span>
        </div>

        <div className="flex justify-end mb-20">
          <h2 className="text-5xl lg:text-6xl font-normal text-white leading-tight max-w-3xl text-right">
            Enhancing User Experience &amp; Mobile Security
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Feature 1 - Privacy First */}
          <div className="bg-black rounded-3xl p-12 hover:scale-105 transition-transform duration-300">
            <div className="w-16 h-16 rounded-full bg-gray-800 flex items-center justify-center mb-8">
              <i className="ri-shield-check-line text-white text-3xl"></i>
            </div>
            <h3 className="text-4xl font-semibold text-white mb-6">Privacy First</h3>
            <p className="text-sm text-gray-400 leading-relaxed">
              We prioritize user privacy with end-to-end encryption and zero-log policies, ensuring your data remains secure and confidential at all times.
            </p>
          </div>

          {/* Feature 2 - Performance */}
          <div className="relative rounded-3xl overflow-hidden hover:scale-105 transition-transform duration-300">
            <img
              src="https://public.readdy.ai/ai/img_res/09131764e3e64610487f2393a6766b76.jpg"
              alt="Performance"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
            <div className="absolute top-6 left-6">
              <div className="inline-flex items-center gap-3 bg-black/60 backdrop-blur-md rounded-xl px-4 py-3">
                <i className="ri-speed-line text-white text-2xl"></i>
                <span className="text-white font-medium">Performance</span>
              </div>
            </div>
            <div className="absolute bottom-6 left-6">
              <h3 className="text-4xl font-semibold text-white">Optimized Speed</h3>
            </div>
          </div>

          {/* Feature 3 - Easy to Use */}
          <div className="bg-gradient-to-br from-gray-700 to-gray-800 rounded-3xl p-12 hover:scale-105 transition-transform duration-300">
            <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center mb-8">
              <i className="ri-smartphone-line text-white text-3xl"></i>
            </div>
            <h3 className="text-4xl font-semibold text-white mb-6">Easy to Use</h3>
            <p className="text-sm text-gray-300 leading-relaxed">
              Intuitive interface designed for seamless user experience. Get started in seconds with our simple and elegant design.
            </p>
          </div>

          {/* Feature 4 - Regular Updates */}
          <div className="bg-gray-800 rounded-3xl p-12 hover:scale-105 transition-transform duration-300">
            <div className="w-16 h-16 rounded-full bg-gray-700 flex items-center justify-center mb-8">
              <i className="ri-refresh-line text-white text-3xl"></i>
            </div>
            <h3 className="text-4xl font-semibold text-white mb-6">Regular Updates</h3>
            <p className="text-sm text-gray-400 leading-relaxed">
              Continuous improvements and new features to keep your apps running smoothly with the latest iOS technologies.
            </p>
          </div>

          {/* Feature 5 - 24/7 Support */}
          <div className="relative rounded-3xl overflow-hidden hover:scale-105 transition-transform duration-300">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20customer%20support%20concept%20with%20communication%20icons%20and%20chat%20bubbles%2C%20modern%20gradient%20green%20and%20teal%20colors%2C%20clean%20minimalist%20design%2C%20professional%20technology%20illustration%20with%20simple%20background&width=400&height=500&seq=feature-support-002&orientation=portrait"
              alt="Support"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-green-900/90 via-green-900/50 to-transparent"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-4xl font-semibold text-white mb-3">24/7 Support</h3>
              <p className="text-sm text-green-100">Always here to help you</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}